
import AutoServiceRadioOption from './AutoServiceRadioOption.vue';
import BCheckbox from 'JS/components/blain-form/BCheckbox.vue';
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import Icon from 'JS/components/Icon.vue';
import { AdditionalServiceResource, AdditionalServiceResourceType, IAdditionalServiceSingleResource, IAdditionalServiceWithOptionsResource } from 'JS/automotive/auto-service-scheduler/types/session';
import { computed, defineComponent, PropType } from 'vue';
import { v4 as uuid } from 'uuid';

export default defineComponent({
	name: 'AutoServiceCheckbox',
	components: {
		BCheckbox,
		BRadioGroup,
		AutoServiceRadioOption,
		Icon,
	},
	props: {
		service: {
			type: Object as PropType<AdditionalServiceResource>,
			required: true,
		},
	},
	emits: ['input', 'radioSelected'],
	setup(props, { emit }) {
		const icon = computed(() => props.service.icon || 'wrench');
		const descriptionId = uuid();
		const disclaimerId = computed(() => props.service.disclaimer ? uuid() : '');
		const priceLabelId = uuid();

		function updateRadio(value: string) {
			emit('radioSelected', value, props.service.name);
		}

		function isMultiple(service: IAdditionalServiceSingleResource | IAdditionalServiceWithOptionsResource): service is IAdditionalServiceWithOptionsResource {
			return service.type === AdditionalServiceResourceType.Multiple;
		}

		return {
			icon,
			updateRadio,
			isMultiple,
			descriptionId,
			disclaimerId,
			priceLabelId,
		};
	}
});
